import { applyOrgRedirect, fetchJSON } from "./utils";

export async function register(data) {
  const url = `/api/auth/register`;
  return fetchJSON(url, null, data, "post");
}

export async function login(data) {
  const url = `/api/auth/login`;
  const response = await fetchJSON(url, null, data, "post");
  return applyOrgRedirect(response);
}
export async function logout() {
  const url = `/api/auth/logout`;
  return fetchJSON(url, null, null, "get");
}
export async function checkAuth(showToastError=true) {
  const url = `/api/auth/check-auth`;
  const response = await fetchJSON(url, null, null, "get", showToastError);
  return applyOrgRedirect(response);
}

export async function forgotPassword(data) {
  const url = `/api/auth/forgot-password`;
  return fetchJSON(url, null, data, "post");
}

export async function resetPassword(data) {
  const url = `/api/auth/reset-password`;
  return fetchJSON(url, null, data, "post");
}

export async function generateSignUpLink(params) {
  const url = `/api/auth/auth-link`;

  params = {
    new_user_id: "1602fa86-59cb-4d3c-8631-9e8bf9314a85",
    sign_email: true,
  };

  return fetchJSON(url, params, null, "get");
}

export async function checkSignupAuthToken(token) {
  const url = `/api/auth/check-auth-token`;
  return fetchJSON(url, { token: token }, null, "get");
}
